// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
var ls = require('local-storage');

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDrFPAjYG5VCSpKY2HtzXldtX_rcoz-KUE",
  authDomain: "tiddle-a2d48.firebaseapp.com",
  projectId: "tiddle-a2d48",
  storageBucket: "tiddle-a2d48.appspot.com",
  messagingSenderId: "132481727699",
  appId: "1:132481727699:web:04b6b010d91d5e5f5ae826",
  measurementId: "G-S7J2MVRR8N"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);
export const db = getFirestore(app);

// Google Analytics is initialized lazily and ONLY after the user has granted
// consent, so no GA cookies or network pings happen before then. Call
// enableAnalytics() once consent is given; log through logAnalytics(), which
// no-ops until analytics is live. See the ConsentBanner in App.js.
let analytics = null;

export function enableAnalytics() {
  if ( analytics )
    return;
  isSupported().then((ok) => {
    if ( ok )
      analytics = getAnalytics(app);
  });
}

export function logAnalytics(name, params) {
  if ( analytics )
    logEvent(analytics, name, params);
}

// Returning visitors who already consented get analytics right away.
if ( ls.get("analyticsConsent") === "granted" )
  enableAnalytics();